@use 'src/globals/main';

pn-footer {
  color: main.$gray700;
  padding-bottom: 2em;
  display: block;

  .pn-footer-row {
    padding: 0.2em 0;
    font-size: 0.9em;
    text-align: center;

    p {
      margin: 0 0.2em 0 0;
      display: inline-block;
    }
  }

  pn-text-link {
    margin-right: 0.5em;
    &:last-child {
      margin-right: 0;
    }
  }
}
